import React, { useEffect } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { apolloClient } from '../../../../services/graphql.service';
import { setFirstClick } from '../../../../helpers/firstClick';
import { ASSET_PATH } from '../../../../consts/env.consts';
import StateSsrClient from '../../../../pages/seo-state-single';
import '../../../../../styles.scss';
import { loadFirebaseAfterPageLoad } from '../../../../helpers/load-firebase';

// eslint-disable-next-line no-undef
__webpack_public_path__ = ASSET_PATH;

const SeoCity = ({ state }) => {
    useEffect(() => {
        setFirstClick();
        loadFirebaseAfterPageLoad();
    }, []);

    return (
        <ApolloProvider client={apolloClient}>
            <StateSsrClient {...{ state }} />
        </ApolloProvider>
    );
};

export default SeoCity;
